import { FormValue } from '@flatsy/types/Applications'

export const shouldResetApplicantDuration = (status?: string | null): boolean => {
  if (status && status !== '') {
    if (
      status === FormValue.proStatus.STUDENT ||
      status === FormValue.proStatus.RETIRED ||
      status === FormValue.proStatus.CDI
    ) {
      return true
    }
  }

  return false
}
